import "./News.css";
import NavigationBar from "../../../components/navbar/NavigationBar";
import PageTitle from "../../../components/Page Title/PageTitle";
import NewsGrid from "../News/NewsGrid";
import "../globals/global.css";

const News = () => {
  return (
    <div className="pagebackground">
      <NavigationBar></NavigationBar>
      <PageTitle title="News from the front"></PageTitle>
      <NewsGrid></NewsGrid>
    </div>
  );
};
export default News;
